import { Routes, Route, Navigate } from 'react-router-dom'
import { Box } from '@mui/material'

import { useAuth } from './contexts/AuthContext'
import { PermissionProvider } from './contexts/PermissionContext'
import Layout from './components/Layout/Layout'
import LoginPage from './pages/Auth/LoginPage'
import DashboardPage from './pages/Dashboard/DashboardPage'
import TransactionsPage from './pages/Transactions/TransactionsPage'
import CategoriesPage from './pages/Categories/CategoriesPage'
import GroupsPage from './pages/Groups/GroupsPage'
import LoansPage from './pages/Loans/LoansPage'
import RemindersPage from './pages/Reminders/RemindersPage'
import ProfilePage from './pages/Profile/ProfilePage'
import PermissionsPage from './pages/Admin/PermissionsPage'
import LoadingSpinner from './components/Common/LoadingSpinner'
import RegisterPage from './pages/Auth/RegisterPage'

function App() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        flexDirection="column"
        gap={2}
      >
        <LoadingSpinner size={60} />
        <Box textAlign="center">
          <Box component="h2" sx={{ margin: 0, color: 'primary.main' }}>
            Financial Tracker
          </Box>
          <Box component="p" sx={{ margin: 0, color: 'text.secondary' }}>
            Loading your financial dashboard...
          </Box>
        </Box>
      </Box>
    )
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  return (
    <PermissionProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/transactions" element={<TransactionsPage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/groups" element={<GroupsPage />} />
          <Route path="/loans" element={<LoansPage />} />
          <Route path="/reminders" element={<RemindersPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/admin/permissions" element={<PermissionsPage />} />
          <Route path="/login" element={<Navigate to="/dashboard" replace />} />
          <Route path="/register" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Layout>
    </PermissionProvider>
  )
}

export default App